import { Button, Tooltip } from 'antd';
import classNames from 'classnames';
import React, { ReactNode } from 'react';

type ButtonClickHandler = (event: React.MouseEvent<HTMLButtonElement>) => void;
type ButtonType = 'button' | 'submit' | 'reset';

interface IProps {
  children?: ReactNode;
  title?: ReactNode;
  onClick?: ButtonClickHandler;
  className?: string;
  disabled?: boolean;
  type?: ButtonType;
  tooltip?: string;
}

const ButtonAction = ({
  children,
  title,
  onClick,
  className,
  type,
  disabled,
  tooltip,
}: IProps) => {
  disabled && (tooltip = undefined);
  const classes = classNames(
    'border-none bg-transparent shadow-none m-0 p-0 flex justify-center items-center',
    disabled && 'cursor-not-allowed',
    className,
  );

  return (
    <Button
      typeof={type}
      disabled={disabled}
      className={classes}
      onClick={onClick}
    >
      {tooltip ? (
        <Tooltip title={tooltip} key={Math.random() * 100}>
          {title} {children}
        </Tooltip>
      ) : (
        <>
          {title} {children}
        </>
      )}
    </Button>
  );
};

export default ButtonAction;
